import { z } from 'zod'

export const jobSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(2, 'Name must be at least 2 characters'),
    schedule: z.string().min(1, 'Schedule is required'),
    policyId: z.number().min(1, 'Policy is required'),
    targetId: z.number().min(1, 'Target is required'),
    enabled: z.boolean().default(true),
    notes: z.string().optional(),
})

export type JobFormData = z.infer<typeof jobSchema>

// Cron expression validation (basic)
export const cronSchema = z.string().refine(
    (value) => {
        const parts = value.split(' ')
        return parts.length === 5 || parts.length === 6
    },
    {
        message: 'Invalid cron expression format',
    }
)

// Common cron presets
export const cronPresets = [
    { label: 'Every minute', value: '* * * * *' },
    { label: 'Every 5 minutes', value: '*/5 * * * *' },
    { label: 'Every 15 minutes', value: '*/15 * * * *' },
    { label: 'Every hour', value: '0 * * * *' },
    { label: 'Every 6 hours', value: '0 */6 * * *' },
    { label: 'Every 12 hours', value: '0 */12 * * *' },
    { label: 'Daily at midnight', value: '0 0 * * *' },
    { label: 'Daily at 2 AM', value: '0 2 * * *' },
    { label: 'Weekly on Sunday', value: '0 0 * * 0' },
    { label: 'Monthly on 1st', value: '0 0 1 * *' },
] as const



